module.exports = __webpack_public_path__ + "static/media/path4.e37326c7.png";